export const PLAYBACK_SPEEDS = [0.5, 1, 1.25, 1.5, 1.75, 2];

export const SHORTCUT_PLAYBACK_SPEEDS = [-8, -4, -2, -1, 1, 2, 4, 8];
